export const ADMIN_GET_CATEGORY = 'ADMIN_GET_CATEGORY'
export const ADMIN_ADD_CATEGORY = 'ADMIN_ADD_CATEGORY'
export const ADMIN_UPDATE_CATEGORY = 'ADMIN_UPDATE_CATEGORY'
export const ADMIN_DELETE_CATEGORY = 'ADMIN_DELETE_CATEGORY'
